import OriginalWebUrlScrapingService from 'client/js/main/services/OriginalWebUrlScrapingService/OriginalWebUrlScrapingService';
import { LINK_TYPE_QR_CODE } from '../../../../../shared/constants';
import { deepCopy } from '../../../../../shared/utils';
import { ReduxAsyncActionsService } from '../../services/ReduxAsyncActions.service';
import type { WrappedReducer } from '../../types/ReduxAsyncActions.types';
import {
  CLEAR_QR_CODE_LINK,
  DUPLICATE_QR_CODE_LINK,
  EDIT_QR_CODE_LINK,
  type QrCodeLinkCreatorAction,
  SET_QR_CODE_LINK_DATA_BASED_ON_URL_SCRAP,
  UPDATE_HAS_QR_CODE_LINK_ANALYTIC_TAGS_STEP_VISITED,
  UPDATE_HAS_QR_CODE_LINK_CUSTOMIZE_STEP_VISITED,
  UPDATE_HAS_QR_CODE_LINK_CUSTOM_LINK_DATA_STEP_VISITED,
  UPDATE_HAS_QR_CODE_LINK_DEFINE_STEP_VISITED,
  UPDATE_HAS_QR_CODE_LINK_REDIRECTS_STEP_VISITED,
  UPDATE_QR_CODE_LINK_ANDROID,
  UPDATE_QR_CODE_LINK_ANDROID_REDIRECT,
  UPDATE_QR_CODE_LINK_CAMPAIGN,
  UPDATE_QR_CODE_LINK_CHANNEL,
  UPDATE_QR_CODE_LINK_CUSTOM_LINK_DATA,
  UPDATE_QR_CODE_LINK_FEATURE,
  UPDATE_QR_CODE_LINK_HAS_BLACKLIST_ERROR,
  UPDATE_QR_CODE_LINK_IOS,
  UPDATE_QR_CODE_LINK_IOS_REDIRECT,
  UPDATE_QR_CODE_LINK_IS_WEB_ONLY,
  UPDATE_QR_CODE_LINK_QR_CODE_CUSTOMIZATION,
  UPDATE_QR_CODE_LINK_STEP,
  UPDATE_QR_CODE_LINK_TAGS,
  UPDATE_QR_CODE_LINK_TITLE,
} from './actions';
import { INIT_STATE } from './constants/qrCodeLinkCreatorInitState';
import type { QrCodeLinkCreatorState } from './types';

const handler = (
  state: WrappedReducer<QrCodeLinkCreatorState>,
  action: QrCodeLinkCreatorAction
): WrappedReducer<QrCodeLinkCreatorState> => {
  switch (action.type) {
    case CLEAR_QR_CODE_LINK: {
      return deepCopy(INIT_STATE);
    }
    case UPDATE_QR_CODE_LINK_STEP: {
      return { ...state, step: action.data.step };
    }
    case UPDATE_HAS_QR_CODE_LINK_DEFINE_STEP_VISITED: {
      return { ...state, defineStepVisited: action.data.visited };
    }
    case UPDATE_HAS_QR_CODE_LINK_ANALYTIC_TAGS_STEP_VISITED: {
      return { ...state, analyticTagsStepVisited: action.data.visited };
    }
    case UPDATE_HAS_QR_CODE_LINK_REDIRECTS_STEP_VISITED: {
      return { ...state, redirectsStepVisited: action.data.visited };
    }
    case UPDATE_HAS_QR_CODE_LINK_CUSTOM_LINK_DATA_STEP_VISITED: {
      return { ...state, customLinkDataStepVisited: action.data.visited };
    }
    case UPDATE_HAS_QR_CODE_LINK_CUSTOMIZE_STEP_VISITED: {
      return { ...state, customizeStepVisited: action.data.visited };
    }
    case UPDATE_QR_CODE_LINK_HAS_BLACKLIST_ERROR: {
      return { ...state, hasBlacklistError: action.data.hasBlacklistError };
    }
    case UPDATE_QR_CODE_LINK_TITLE: {
      return { ...state, title: action.data.title };
    }
    case UPDATE_QR_CODE_LINK_FEATURE: {
      return { ...state, feature: action.data.feature };
    }
    case UPDATE_QR_CODE_LINK_CHANNEL: {
      return { ...state, channel: action.data.channel };
    }
    case UPDATE_QR_CODE_LINK_CAMPAIGN: {
      return { ...state, campaign: action.data.campaign };
    }
    case UPDATE_QR_CODE_LINK_TAGS: {
      return { ...state, tags: action.data.tags };
    }
    case UPDATE_QR_CODE_LINK_IOS: {
      return { ...state, ios: action.data.ios };
    }
    case UPDATE_QR_CODE_LINK_IOS_REDIRECT: {
      return { ...state, iosRedirect: action.data.iosRedirect };
    }
    case UPDATE_QR_CODE_LINK_ANDROID: {
      return { ...state, android: action.data.android };
    }
    case UPDATE_QR_CODE_LINK_ANDROID_REDIRECT: {
      return { ...state, androidRedirect: action.data.androidRedirect };
    }
    case UPDATE_QR_CODE_LINK_IS_WEB_ONLY: {
      return { ...state, isWebOnly: action.data.isWebOnly };
    }
    case UPDATE_QR_CODE_LINK_CUSTOM_LINK_DATA: {
      return { ...state, linkData: [...action.data.customLinkData] };
    }
    case UPDATE_QR_CODE_LINK_QR_CODE_CUSTOMIZATION: {
      return { ...state, qrCodeCustomization: action.data.qrCodeCustomization };
    }
    case EDIT_QR_CODE_LINK: {
      return { ...state, ...action.data.qrCodeLinkToEdit };
    }
    case DUPLICATE_QR_CODE_LINK: {
      return { ...state, ...action.data.qrCodeLinkToDuplicate };
    }
    case SET_QR_CODE_LINK_DATA_BASED_ON_URL_SCRAP: {
      const previousData = {
        linkData: state.linkData,
        title: state.title || undefined,
        type: LINK_TYPE_QR_CODE,
      };

      const scrapingService = new OriginalWebUrlScrapingService(previousData, action.data);
      const newState = { ...state };

      if (scrapingService.shouldLinkDataUpdate) {
        newState.linkData = scrapingService.linkDataItems;
      }

      if (scrapingService.shouldLinkTitleUpdate) {
        newState.title = scrapingService.linkTitleValue;
      }

      return newState;
    }
    default: {
      return state;
    }
  }
};

const QrCodeLinkCreatorReducer = ReduxAsyncActionsService.wrapReducer(deepCopy(INIT_STATE), handler, {});

export default QrCodeLinkCreatorReducer;
